import React from 'react'

function AboutCompony() {
  return (
    <div className='c-about-Compony'>
        <div className='about-Compony' style={{flexDirection: "row" , padding: "30px 8px" , direction: "rtl"}}>
            <div className='about-C-item'> 
                <img className='img-about' src="image/vector-pic-about.jpg" alt="" />
            </div>
            <div className='about-C-item' style={{paddingLeft: "20px"}}>
                  <p className='title-about'>  درباره ما </p>
                  <div className='textJustify'> ما در زمینه تأمین و توزیع انواع آهن‌آلات و سنگ‌های ساختمانی فعالیت می‌کنیم و با ارائه محصولات باکیفیت، به نیازهای پروژه‌های ساختمانی و صنعتی پاسخ می‌دهیم. گروه آهن شامل محصولاتی مانند تیرآهن، میلگرد، نبشی و پروفیل است که در ساخت سازه‌های مقاوم و ایمن کاربرد دارند. هدف ما ارائه محصولاتی با استاندارد بالا و جلب رضایت کامل مشتریان است. </div>
                  {/* <div className='btn-abotu'> Lorem ipsum  </div> */}
            </div>
        </div>
    </div>
  )
}

export default AboutCompony
